<script setup lang="ts">
import { useRoute } from 'vue-router';

import VLogo from '@components/logo/VLogo/VLogo.vue';
import { ERouteNamespace } from '@modules/core/services/router/enums';
import TheLanguageSelector from '@modules/i18n/components/TheLanguageSelector/TheLanguageSelector.vue';
import NewAppVersion from '@modules/new-app-version/components/NewAppVersion/NewAppVersion.vue';
import HeaderNotification from '@modules/notification/components/HeaderNotification/HeaderNotification.vue';

const route = useRoute();
</script>

<template>
  <div v-data-qa-auto-id="'TheAnonymousLayout'" class="flex h-full flex-col">
    <HeaderNotification
      v-if="route.meta?.namespace === ERouteNamespace.ANONYMOUS"
      class="flex-none"
      :namespace="ERouteNamespace.ANONYMOUS"
    />
    <div class="flex grow flex-col content-between items-center justify-between p-4">
      <div class="flex w-full flex-col items-end">
        <TheLanguageSelector
          class="mr-4 mt-4"
          is-dark
        />
      </div>
      <div class="flex flex-col gap-4">
        <div class="mx-auto mb-6 max-w-[400px]">
          <VLogo type="logo" />
        </div>
        <RouterView />
      </div>
      <div class="mb-6 mt-16 flex flex-col items-center text-muted-color">
        <div class="mb-8">
          <NewAppVersion />
        </div>
        <p>Powered by Q</p>
      </div>
    </div>
  </div>
</template>
